import React from 'react';
import PropTypes from 'prop-types';
import { LineItem } from './LineItem';
import { generateUniqueKey } from '../../helpers/utilities';

const ReferralGroup = ({ ...props }) => {
  return (
    <React.Fragment>
      <ul className='list'>
        <li className='heading'>
          {props.groupName}
        </li>
        {props.referralGroup.map(r =>
          <LineItem
            item={r}
            key={generateUniqueKey()}
            selectRefferal={props.selectRefferal}
            currentReferralFilter={props.currentReferralFilter}
          />)}
      </ul>
    </React.Fragment>
  );
};

ReferralGroup.propTypes = {
  referralGroup: PropTypes.array.isRequired,
  selectRefferal: PropTypes.func.isRequired,
  groupName: PropTypes.string,
  currentReferralFilter: PropTypes.string
};

export default ReferralGroup;
